import { getAuth } from 'firebase/auth'

// Lazy — do not call at module load time, before initializeApp() runs.
export const getFirebaseAuth = () => getAuth()
